import { connect } from "react-redux";
import { createFeedback } from "../../../action/common/commonActionCreator";
import { ISendMail } from "../../../models/common/IUserProfile";
import SweetAlert from "react-bootstrap-sweetalert";
import { useState } from "react";
import { IFacultyBroadCast } from "../../../models/faculty/facultyConnect";
import { getAlertData } from "../../../helper/sweet-alert";
import { UserRole } from "../../../constants/RoleEnum";
import LoaderSpinner from "../../../common-components/loader";
import { baseURL } from "../../../constants/commonConstants";
import { mailValidation } from "../../../common-functions/commonFunctions";

const FacultyBroadcast = (props: IFacultyBroadCast) => {
  const { setShowCompose, SendMail, currentUser, toEmails } = props;
  const [content, setContent] = useState<string>("");
  const [subject, setSubject] = useState<string>("");
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [showAlertCancel, setShowAlertCancel] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const handleSendMail = () => {

    let alertData = mailValidation(subject, content, toEmails.map(e => e.email),)
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
      return
    }

    const mailData: ISendMail = {
      toEmail: toEmails.map(e => e.email),
      subject: subject,
      content: `${content}\<br>\<br>Regards,\<br>${currentUser.displayName}\<br>${currentUser.currentRole && UserRole[currentUser.currentRole]}`,
    };
    SendMail(mailData, setAlert);
    setIsLoading(true);
  };

  const onConfirm = () => {
    setShowAlert(false);
    setIsLoading(false);
    if (subject && content) {
      setShowCompose(false);
    }
  };

  return (
    <>
      <div className="modal-body">
        <h2>Compose</h2>
        <p>
          Summarize your query briefly and
          send it to the chosen recipient. You can expect a reply within 24
          hours.
        </p>
        <div className="emailform mt-3">
          <div className="label-to">
            <label htmlFor="">From</label>
            <div className="stude-details">
              <div className="img">
                <img src={baseURL && currentUser?.image ? baseURL + currentUser.image : ""} alt=""
                  onError={(e) => { e.currentTarget.src = "/assets/images/icon/DefaultImage.jpeg" }}
                />
              </div>
              <div className="desc">
                <h6>{currentUser.displayName}</h6>
                <p>
                  {currentUser.currentDepartment?.name} | <span>{currentUser.currentCollege?.name}</span>
                </p>
              </div>
            </div>
          </div>
          <div className="multiselect-plugin label-to">
            <label htmlFor="">To</label>
            <div id="htmlselect" className="pt-1 to-email-box">
              <input
                className="w-100 to-email-input"
                type="text"
                id="to"
                value={
                  toEmails.length <= 4
                    ? toEmails.map((e) => e.name).join(", ")
                    : `${toEmails.slice(0, 4).map((e) => e.name).join(", ")}   +${toEmails.length - 4} more`
                }
                title={
                  toEmails.length > 4
                    ? toEmails.slice(4).map((e) => e.name).join(", ")
                    : ""
                }
              />
            </div>
          </div>
          <div className="formgroup">
            <label htmlFor="">Subject</label>
            <input
              type="text"
              id="subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
            />
          </div>
          <div className="formgroup">
            <label htmlFor="">Message</label>
            <textarea
              name=""
              id="message"
              value={content}
              onChange={(e) => setContent(e.target.value)}
            ></textarea>
          </div>
        </div>
      </div>
      <div className="modal-footer mb-4">
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSendMail}
        >
          Send
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          data-bs-dismiss="modal"
          onClick={() => setShowCompose(false)}
        >
          Cancel
        </button>
      </div>
      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={showAlertCancel}
        onCancel={() => {
          setShowAlert(false);
          setShowAlertCancel(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={showAlertCancel ? "Yes" : "Ok"}
      ></SweetAlert>
      {isLoading && (<LoaderSpinner />)}
    </>
  )
}

const mapDispatchToProps = {
  SendMail: (brodCastMail: ISendMail, callback: Function) =>
    createFeedback(brodCastMail, callback)
};

function mapStateToProps(state: any) {
  return {
    currentUser: state.userDetails.userProfileData,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FacultyBroadcast)